/**
 * @generated SignedSource<<b5c6d58308696cbd06ffb54a37e99359>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateJiraVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createJiraVerificationKeyMutation$variables = {
  input: CreateJiraVerificationKeyInput;
};
export type createJiraVerificationKeyMutation$data = {
  readonly createJiraVerificationKey: {
    readonly company: {
      readonly jiraVerificationKey: string | null;
    } | null;
  } | null;
};
export type createJiraVerificationKeyMutation = {
  variables: createJiraVerificationKeyMutation$variables;
  response: createJiraVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraVerificationKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createJiraVerificationKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraVerificationKeyPayload",
        "kind": "LinkedField",
        "name": "createJiraVerificationKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createJiraVerificationKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraVerificationKeyPayload",
        "kind": "LinkedField",
        "name": "createJiraVerificationKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d84227ddbe14db225faf8154dba83e3d",
    "id": null,
    "metadata": {},
    "name": "createJiraVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createJiraVerificationKeyMutation(\n  $input: CreateJiraVerificationKeyInput!\n) {\n  createJiraVerificationKey(input: $input) {\n    company {\n      jiraVerificationKey\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a0ccbea5711e11af3cd06f1a6804fda";

export default node;
